import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function Categories ({ localRawCategory, setLocalRawCategory }) {
  const handleRawCategory = event => {
    setLocalRawCategory(event.target.value)
  }

  return (
    <div>
      <div>
        <div className={styles.locationInputWrapper}>
          <div className={styles.inlineLabel}>
            <label className={styles.locationLabel} htmlFor='rawCategories'>
              Raw categories
            </label>
            <Tooltip
              title="The raw category text provided by the source (not normalized)."
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Raw categories help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.locationInput}
            type='text'
            id='prevent_autofill'
            autoComplete='off'
            placeholder='Text'
            value={localRawCategory}
            onChange={handleRawCategory}
          />
        </div>
      </div>
    </div>
  )
}

export default Categories
